function endpointFieldChange( value, endpointId, field ) {
	return {
		type: 'ENDPOINT_FIELD_CHANGE',
		payLoad: {
			value,
			endpointId,
			field
		}
	}
}

function handleEndpointSwitcher( value, endpointId ) {
	return {
		type: 'HANDLE_ENDPOINT_SWITCHER',
		payLoad: {
			value,
			endpointId
		}
	}
}

function endpointAddNew() {
	return {
		type: 'ENDPOINT_ADD_NEW'
	}
}

function endpointRemove( endpointId ) {
	return {
		type: 'ENDPOINT_REMOVE',
		payLoad: {
			endpointId
		}
	}
}

export { endpointFieldChange, handleEndpointSwitcher, endpointAddNew, endpointRemove };